import React from "react";
import {render} from "react-dom";
import PriceBlockContainer from "../../components/PriceBlockContainer/PriceBlockContainer";
import getPostCode from "../../utils/getPostCode";
import isProductInWishlist from "../../utils/isProductInWishlist";
import StateManager from "../../utils/StateManager";
import getInitialState from "./getInitialState";
import {reducer} from "./PriceBlockReducer";
import isMaxUser from "../../utils/isMaxUser";
import PriceBlockUseCase from "./PriceBlockUseCase";
import {getBranchId, getBranchName} from "../../components/BranchSelector/branchSelectorUtils";


const init = async (priceService, templateContext, stockService, stockBranchesService,
              suburbServiceClient, clearancePriceServiceClient) => {
  const { userType, gstFree, pack1Uom, productCode } = templateContext;

  const branchId = isMaxUser(userType) ? await getBranchId() : undefined;
  const branchName = isMaxUser(userType) ? await getBranchName() : undefined;
  const initialState = getInitialState(userType, gstFree, pack1Uom, getPostCode(), isProductInWishlist(productCode), branchId, branchName);
  const stateManager = StateManager.createInstance(reducer, initialState);
  const useCase = PriceBlockUseCase.createInstance(priceService, templateContext, stateManager, stockService, stockBranchesService, suburbServiceClient, clearancePriceServiceClient);

  const element = document.querySelector("#pdp-price-block");

  useCase.handleInitialPageLoad(initialState);

  stateManager.onStateChange(state => {
    render(
      <PriceBlockContainer
        state={state}
        useCase={useCase}
        templateContext={templateContext}
      />,
      element
    );
  });
};

export default { init };
